import { AuthHttp } from "@/http-helper.js";
import router from "@/router.js";
import moment from "moment";
import Roles from "@/roles/roles";

const getDefaultState = () => {
  return {
    token: "",
    errors: null,
    user: {},
    sabbath: false,
  };
};

const state = getDefaultState();

const getters = {
  getToken: (state) => state.token,
  getErrors: (state) => state.errors,
  getUser: (state) => state.user,
  getUserEditApartments: (state) => state.user.edit_apartments_ids || null,
  getUserRole: (state) => state.user.role_slug || null,
  getSabbath: (state) => state.sabbath,
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setError(state, errors) {
    state.errors = errors;
  },
  setUser(state, user) {
    state.user = user;
  },
  pushUserEditApartment(state, id) {
    state.user.edit_apartments_ids.push(id);
  },
  setUserEditApartments(state, ids) {
    state.user.edit_apartments_ids = ids;
  },
  setSabbath(state, sabbath) {
    state.sabbath = sabbath;
  },
};

const actions = {
  login({ commit }, user) {
    const zone = moment().utcOffset() / 60;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let dst = 0;

    if (moment().isDST()) {
      dst = 1;
    }

    const formData = new FormData();
    formData.set("email", user.email);
    formData.set("password", user.password);
    formData.set("grant_type", "password");
    formData.set("timezone_offset", zone);
    formData.set("timezone", timezone);
    formData.set("timezone_dst", dst);
    formData.set("isWeb", 1);

    return AuthHttp.post("api/v2/login", formData)
      .then((response) => {
        commit("setToken", response.data.access_token);
        commit("setUser", response.data.user);
        if (response.data.user.role_slug === Roles.TOW_DRIVER) {
          router.push({ name: "enforcements.Dashboard" });
        } else {
          router.push({ name: "dashboard" }).catch(() => {});
        }
      })
      .catch((e) => {
        commit("setError", e.response.data.errors);
      });
  },
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  resetErrors({ commit }, errors) {
    commit("setError", null);
  },
  setSabbath({ commit }, sabbath) {
    commit("setSabbath", sabbath);
  },
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js